export const ALL_RESOURCES_FOLDER = "all";

export const STORAGE_UPGRADE_LINK = "https://share.hsforms.com/1aoERY4lrQ0GOQeRlXahNAQ3is1h";
